<div class="min-h-screen overflow-x-hidden bg-white font-sans text-[#171923]">
  <app-headerhome></app-headerhome>

  @if (landing) {
    <main>
      <section class="relative isolate overflow-hidden bg-slate-950 px-6 py-20 text-white sm:py-28">
        @if (landing.image) {
          <img class="absolute inset-0 -z-20 size-full object-cover opacity-35" [src]="landing.image" [alt]="landing.destination">
        }
        <div class="absolute inset-0 -z-10 bg-gradient-to-r from-slate-950 via-slate-950/85 to-slate-950/30"></div>
        <div class="mx-auto max-w-[1050px]">
          <p class="mb-3 text-sm font-bold uppercase tracking-[0.16em] text-red-300">Mash Poa bus route</p>
          <h1 class="max-w-[760px] font-display text-4xl font-extrabold leading-tight sm:text-5xl">
            {{ landing.origin }} to {{ landing.destination }} bus tickets
          </h1>
          <p class="mt-5 max-w-[650px] text-base leading-7 text-white/80 sm:text-lg">
            Search schedules, compare available departure times and reserve your preferred seat online with {{ operatorName }}.
          </p>
          <button type="button" class="focus-ring mt-8 rounded-xl border-0 bg-red-600 px-6 py-3.5 text-base font-extrabold text-white transition hover:bg-red-700" (click)="searchBuses()">
            Search {{ landing.origin }} to {{ landing.destination }} buses
          </button>
        </div>
      </section>

      <section class="px-6 py-16">
        <div class="mx-auto grid max-w-[1050px] gap-8 md:grid-cols-[1.4fr_1fr]">
          <article>
            <h2 class="font-display text-2xl font-extrabold">Travel from {{ landing.origin }} to {{ landing.destination }}</h2>
            <p class="mt-4 max-w-[680px] text-[15.5px] leading-7 text-slate-600">
              Use the live booking search to see travel dates, departure and arrival times, fares and current seat availability for this route. Availability can change as passengers complete their bookings.
            </p>
            <p class="mt-4 max-w-[680px] text-[15.5px] leading-7 text-slate-600">
              Once you choose a trip, select your seat and boarding point before completing secure payment online.
            </p>
          </article>
          <aside class="rounded-2xl border border-slate-200 bg-slate-50 p-6">
            <h2 class="font-display text-lg font-extrabold">Route information</h2>
            <dl class="mt-5 space-y-4 text-sm">
              <div><dt class="font-bold text-slate-500">Departure</dt><dd class="mt-1 text-base font-extrabold">{{ landing.origin }}</dd></div>
              <div><dt class="font-bold text-slate-500">Destination</dt><dd class="mt-1 text-base font-extrabold">{{ landing.destination }}</dd></div>
              <div><dt class="font-bold text-slate-500">Operator</dt><dd class="mt-1 text-base font-extrabold">{{ operatorName }}</dd></div>
            </dl>
          </aside>
        </div>
      </section>
    </main>
  } @else {
    <main class="mx-auto flex min-h-[60vh] max-w-[720px] flex-col items-center justify-center px-6 text-center">
      <h1 class="font-display text-3xl font-extrabold">Route not found</h1>
      <p class="mt-3 text-slate-600">This route does not have a public booking page.</p>
      <a routerLink="/" fragment="search" class="focus-ring mt-6 rounded-xl bg-red-600 px-5 py-3 font-bold text-white">Search all routes</a>
    </main>
  }

  <app-footer></app-footer>
</div>
